// extracted by mini-css-extract-plugin
export default {"desktopGalleryContainer":"Home_desktopGalleryContainer__iHFCx","mobileGalleryContainer":"Home_mobileGalleryContainer__k9V4m"};